require('./header.component.scss');

// @vendors
import PropTypes from 'prop-types';

// @components
import { OKButton } from 'commonsComponents/OKButton';
import { useSelector } from 'react-redux';
import { migrationKeys } from '../../migrationUsersBranchView.poeditor';

// @helpers
const { FormattedText } = require('core/i18n').i18n;

const bankLogo = require('../../assets/openbank-logo.svg');
const closeIcon = require('../../assets/close.svg');

export const Header = ({ leftSideText, exitButton }) => {
  const immScreen = useSelector(state => state.screen);

  return (
    <>
      <div className="ok-layout-migration-header">
        <div className="ok-layout-migration-header__sections">
          {leftSideText && (
            <div className="ok-layout-migration-header__left-text">{leftSideText}</div>
          )}
          <img className="ok-layout-migration-header__logo" src={bankLogo} />
          {!!exitButton &&
            (immScreen.get('isMobile') ? (
              <img
                className="ok-layout-migration-header__close-icon"
                src={closeIcon}
                onClick={exitButton.handleClickButton}
              />
            ) : (
              <OKButton modifier="link-ghost" inverse onClick={exitButton.handleClickButton}>
                <FormattedText value={migrationKeys.headerExitButton} />
              </OKButton>
            ))}
        </div>
        {immScreen.get('isMobile') && leftSideText && (
          <div className="ok-layout-migration-header__separator" />
        )}
      </div>
      {leftSideText && immScreen.get('isMobile') && (
        <div className="ok-layout-migration-header__mobile-text">{leftSideText}</div>
      )}
    </>
  );
};

Header.propTypes = {
  leftSideText: PropTypes.string,
  handleExitLeaveModal: PropTypes.func.isRequired,
  exitButton: PropTypes.shape({
    handleClickButton: PropTypes.func,
  }),
};
